// @ts-nocheck
// oxlint-disable no-unused-vars
import { apiFetch, type ApiResponse } from "@/api/fetch";

/** Auto-generated file. Do not edit. */

/**
 * GET `/health`
 */
export const getApiHealth = () =>
	apiFetch<ApiResponse<null>>({
		uri: "health",
		method: "GET",
	});
